import { render, staticRenderFns } from "./VirtualKeyboard65GameBoy.vue?vue&type=template&id=036d54fd&scoped=true&"
import script from "./VirtualKeyboard65GameBoy.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboard65GameBoy.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboard65GameBoy.vue?vue&type=style&index=0&id=036d54fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036d54fd",
  null
  
)

export default component.exports